var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    transform: "translate(-1129 -601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    transform: "translate(1129 601)",
    fill: "#fff",
    stroke: "#e3e3e3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x31__stroke",
    transform: "translate(1143.118 613.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 19,
    height: 19,
    transform: "translate(-0.118 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M5.253,39.851a5.61,5.61,0,0,1,.285-1.761l-3.2-2.442a9.554,9.554,0,0,0,0,8.4l3.2-2.447a5.613,5.613,0,0,1-.282-1.754",
    transform: "translate(-1.163 -30.363)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M16.466,3.882a5.5,5.5,0,0,1,3.5,1.251l2.764-2.76A9.5,9.5,0,0,0,7.938,5.285l3.2,2.442a5.6,5.6,0,0,1,5.33-3.845",
    transform: "translate(-6.761)",
    fill: "#ea4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M16.466,79.726a5.6,5.6,0,0,1-5.33-3.845l-3.2,2.442a9.473,9.473,0,0,0,8.528,5.286,9.055,9.055,0,0,0,6.191-2.365L19.621,78.9a5.878,5.878,0,0,1-3.156.83",
    transform: "translate(-6.761 -64.631)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M74.527,54.089a7.859,7.859,0,0,0-.216-1.725H65.457V56.03h5.1a4.273,4.273,0,0,1-1.941,2.836l3.035,2.347a9.437,9.437,0,0,0,2.879-7.124",
    transform: "translate(-55.752 -44.601)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ccc44202d75f8ae7cf41f783ee8e3111.svg";
export { ForwardRef as ReactComponent };